//events - a super-basic Javascript (publish subscribe) pattern
class Event {
  constructor() {
    this.events = {};
  }
  on(eventName, fn) {
    this.events[eventName] = this.events[eventName] || new Set();
    if ((this.events[eventName]?.size ?? 0) <= 0) {
      this.events[eventName].add(fn);
    }
  }
  off(eventName, fn) {
    if ((this.events[eventName]?.size ?? 0) > 0) {
      this.events[eventName].delete(fn);
    }
  }
  trigger(eventName, data) {
    if ((this.events[eventName]?.size ?? 0) > 0) {
      const eventHandlers = [...this.events[eventName]].filter(item => !!item).map(fn => fn(data));
      return Promise.all(eventHandlers);
    } else {
      return Promise.resolve();
    }
  }
}
export default new Event();